import React, { useContext, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { BsArrowRight, BsArrowUp } from 'react-icons/bs';
import { set } from 'date-fns';
import { DotLoader, PulseLoader } from 'react-spinners';

function AiAssistantScreen() {
    const navigate = useNavigate();
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const {setUserProfile, userProfile, logOutFunction, reloadUser} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [messgesList, setMessageList] = useState([]);
    const [message, setMessage] = useState('');

    const submit = async (message_req) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("question", message_req);

        try {
            const response = await axios.post(base_url + '/ai/function.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                const now = new Date();
                let hours = now.getHours();            // returns 0–23
                const minutes = now.getMinutes();      // returns 0–59
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;                    // convert to 12-hour format
                hours = hours ? hours : 12;           // hour '0' should be '12'
                const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
                setMessageList(prev => [
                    ...prev,
                    { text: response.data.message, sender: 'bot', time: formattedTime }
                ]);
                scrollToBottom()
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

    const sendNewMessage = async () => {
        const new_array = messgesList;
        const now = new Date();
        let hours = now.getHours();            // returns 0–23
        const minutes = now.getMinutes();      // returns 0–59
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;                    // convert to 12-hour format
        hours = hours ? hours : 12;           // hour '0' should be '12'
        const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

        // new_array.push({'text': message, 'sender': 'user', 'time': formattedTime})
        // await setMessageList([...new_array, {'text': message, 'sender': 'user', 'time': formattedTime}]);
        await setMessageList(prev => [
            ...prev,
            { text: message, sender: 'user', time: formattedTime }
        ]);
        // console.log(messgesList)
        setTimeout(() => {
            submit(message);
        }, 500)
        scrollToBottom()
        setMessage('');
    }

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "auto" });
    };

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='h-[-webkit-fill-available] flex flex-row justify-between'>
                    <div className="w-full px-5 md:px-10 pt-[2rem] bg-[#FAFAFA] rounded-lg">
                        <div ref={messagesEndRef} className='w-[100%] md:w-[80%] h-[70%] mx-auto flex flex-col overflow-y-auto'>
                            {messgesList?.map((chat, index) => (
                                <div key={index} className={`mb-2 w-full flex flex-col ${chat.sender == 'user' ? 'items-end' : 'items-start'}`}>
                                    <div className={`w-[fit-content] p-3 rounded-[10px] ${chat.sender == 'user' ? 'bg-yellow' : 'bg-yellow-light'}`}>
                                        <p>{chat.text}</p>
                                    </div>
                                    <p className='text-xs text-[#585858]'>{chat.time}</p>
                                </div>
                            ))}
                            {loading && (
                                <div className={`mb-2 w-full flex flex-col items-start`}>
                                    <div className={`w-[fit-content] p-3 rounded-[10px] bg-yellow-light`}>
                                        <PulseLoader
                                            color={'#F4D00F'}
                                            loading={loading}
                                            size={10}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    </div>
                                    <p className='text-xs text-[#585858]'>{'Assistant is typing...'}</p>
                                </div>
                            )}
                        </div>
                        <div className='w-full md:w-[80%] mt-3 mx-auto'>
                            <div className="flex mx-auto p-5 py-2 w-full rounded-[10px] bg-[#FBE7A7] items-center space-x-2">
                                {/* Plus icon */}
                                {/* <button className="p-2 text-gray-600 hover:text-black">
                                <Plus size={20} />
                                </button> */}

                                {/* Input field */}
                                <textarea
                                type="text"
                                aria-multiline
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="What do you need help with?"
                                className="min-h-[100px] w-full py-3  border-none focus:ring-0 outline-none bg-transparent text-gray-800 placeholder-gray-500"
                                ></textarea>

                                {/* Mic icon */}
                                {/* <button className="p-2 text-gray-600 hover:text-black">
                                <Mic size={20} />
                                </button> */}

                                {/* Send icon */}
                                <button onClick={() => sendNewMessage()} className="p-4 bg-yellow rounded-full text-gray-600 hover:text-black">
                                    <BsArrowRight size={20} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default AiAssistantScreen;
